"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Transition subsystem
 *
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @preferred @publicapi @module transition
 */ /** */
__export(require("./interface"));
__export(require("./hookBuilder"));
__export(require("./hookRegistry"));
__export(require("./rejectFactory"));
__export(require("./transition"));
__export(require("./transitionHook"));
__export(require("./transitionEventType"));
__export(require("./transitionService"));
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@uirouter/core/lib/transition/index.js
 ** module id = 883
 ** module chunks = 8
 **/